import React, { useState } from 'react';
import '../css/header/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // For contact, scroll to contact-info section for better mobile experience
      if (sectionId === 'contact') {
        const contactInfo = document.getElementById('contact-info');
        if (contactInfo) {
          // Add offset for mobile to ensure contact info is visible
          const isMobile = window.innerWidth <= 768;
          const offset = isMobile ? 80 : 20;
          
          const elementPosition = contactInfo.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
          setIsMenuOpen(false);
          return;
        }
      }
      
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src="/logo.jpg" alt="Samapaw Sampatti Pvt Ltd" className="logo-image" />
            <div className="logo-text">
              <span className="company-name">Samapaw Sampatti</span>
              <span className="company-type">Private Limited</span>
            </div>
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-menu">
              <li><button onClick={() => scrollToSection('home')} className="nav-link">Home</button></li>
              <li><button onClick={() => scrollToSection('about')} className="nav-link">About</button></li>
              <li><button onClick={() => scrollToSection('services')} className="nav-link">Services</button></li>
              <li><button onClick={() => scrollToSection('team')} className="nav-link">Team</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button></li>
            </ul>
          </nav>
          
          <button className="mobile-menu-btn" onClick={toggleMenu}>
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;